// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Fetch from '@/utils/Fetch';
import ManageJobSchedule from '@/components/job-schedule/manage';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'

function EditJobSchedule() {

  const router = useRouter();
  const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: jobSchedule } = useQuery(
    ['jobSchedule', id],
    () => Fetch.get({ url: `/JobSchedule/${id}` }),
    { enabled: !!id }
  );

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(router.replace, "/");
    }
  }, [accessStatus]);

  if (!jobSchedule) return null;

  return (
    <div>
      <ManageJobSchedule isNew={false} jobSchedule={jobSchedule} accessStatus={accessStatus} customerID={jobSchedule.CustomerID} />
    </div>
  );
}

export default EditJobSchedule

export const Route = createFileRoute('/_authenticated/job-schedule/$id')({ component: EditJobSchedule })
